<template>
  <div class="wrap_elem" v-if="master">
    <div class="right_top_mobile">
      <button @click="$emit('back')">
        <img
          src="../../../../assets/images/icons/chevron-left-black.svg"
          alt=""
        />
      </button>
    </div>
    <div class="left">
      <div class="img">
        <div :style="{ 'background-image': `url('${master.avatar}')` }"></div>
      </div>
      <div class="title">{{ getName(master) }}</div>
      <div class="phone">{{ master.phone }}</div>
      <div class="phone" v-if="master.email">{{ master.email }}</div>
      <div class="phone">
        Бонусные баллы: <strong>{{ master.points || 0 }}</strong>
      </div>
      <div class="phone">
        Приветственный бонус: <strong>{{ master.hours || 0 }} ч.</strong>
      </div>

      <div class="authed" v-if="master.authorized_at">мастер авторизован</div>
      <div class="authed error" v-else>мастер не авторизован</div>

      <div class="authed error" v-if="isFrozen">
        мастер заморожен до {{ getDate(master.frozen[0].end_at) }}
      </div>

      <div style="justify-content: center;display: flex" v-if="!isFrozen">
        <div
          style="display: flex; flex-wrap: wrap;justify-content: space-between;width: 320px"
        >
          <div style="width: 60%">
            <custom-input
              class="pd-5px"
              v-model="frozenDate"
              :type="'datetime-local'"
            />
            <error-text :text="frozenErrors.end_at" />
          </div>
          <button-component
            variant="outlined"
            style="width: 38%"
            @click="frozen()"
            >Заморозить</button-component
          >
        </div>
      </div>

      <button-component
        variant="outlined"
        mt="10px"
        @click="createConversation(master.id)"
        >Написать мастеру</button-component
      >
      <input
        type="file"
        ref="file"
        style="display: none;"
        @change="sendContract"
      />

      <button-component
        variant="filled"
        mt="10px"
        v-if="master.vacation"
        @click="vacation"
        >Мастер вернулся к работе</button-component
      >
      <button-component variant="filled" mt="10px" v-else @click="vacation"
        >Мастер ушел в отпуск</button-component
      >

      <template v-if="!master.contract">
        <button-component variant="filled" mt="10px" @click="$refs.file.click()"
          >Загрузить скан договора</button-component
        >
      </template>
      <template v-else>
        <button-component
          variant="filled"
          mt="10px"
          @click="openInNewTab(master.contract)"
          >Открыть скан договора</button-component
        >
        <button-component
          variant="filled"
          mt="10px"
          v-if="!master.authorized_at"
          @click="authorize"
          >Авторизовать мастера</button-component
        >
      </template>

      <div class="packages" v-if="packages.length" style="margin-top: 20px">
        <PackagesCard
          v-for="(p, idx) in packages"
          :key="idx"
          :title="p.zone_name"
          :end="p.end_at"
          :hours="p.hours"
          :last-hours="p.last_hours"
          mb="10px"
        ></PackagesCard>
      </div>
    </div>
    <div class="right">
      <preload-content :loading="loading">
        <h3>Аренды рабочего места</h3>
        <ul>
          <li v-for="(item, index) in rents" :key="index">
            <router-link to="#">
              <span class="title">{{ item.zone.name }}</span>
              <span class="gray">{{ item.start_at }}, {{ item.end_at }}</span>
            </router-link>
          </li>
          <p style="text-align: center" v-if="!rents.length">Нет данных</p>
          <div class="more" v-if="canLoadMoreRents">
            <button @click="getRents(true)">Еще</button>
          </div>
        </ul>
      </preload-content>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import preloadContent from "@/components/ui/preload-content";
import ButtonComponent from "@/components/ui/buttons/button-component";
import PackagesCard from "@/components/ui/card/packages-card";
import ChatMixin from "@/mixins/chat";
import moment from "moment/moment";
import CustomInput from "@/components/ui/inputs/custom-input";
import ErrorText from "../../../../components/ui/text/error-text";

export default {
  name: "AdministratorMasterComponent",
  components: {
    PackagesCard,
    ButtonComponent,
    preloadContent,
    CustomInput,
    ErrorText,
  },
  props: ["master"],
  mixins: [ChatMixin],
  data: () => ({
    rentPage: 1,
    rentLastPage: 1,
    rents: [],
    loading: false,
    contract: null,
    packages: [],
    frozenDate: null,
    frozenErrors: {},
  }),
  mounted() {
    this.getRents();
    this.getTariffs();
  },
  methods: {
    frozen() {
      this.$api.admin.master
        .frozen(this.master.id, { end_at: this.frozenDate })
        .then((frozen) => {
          let mt = Object.assign({}, this.master);
          mt.frozen.push(frozen);
          mt.vacation = 1;
          this.$emit("updated", mt);
        })
        .catch(({ response }) => {
          this.frozenErrors = response.data.errors;
        });
    },
    getDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    getDateTimeLocal(date) {
      if (!date) return null;
      return moment(date)
        .local()
        .format();
    },
    vacation() {
      this.$api.admin.master
        .vacation(this.master.id)
        .then(({ data }) => this.$emit("updated", data));
    },
    getName(master) {
      return master.name || master.surname
        ? (master.name || "") + " " + (master.surname || "")
        : "Не указанно";
    },
    openInNewTab(url) {
      var win = window.open(url, "_blank");
      win.focus();
    },
    resetRentData() {
      this.rents = [];
      this.rentPage = 1;
      this.rentLastPage = 1;
    },
    ...mapMutations(["openModal"]),
    getTariffs() {
      this.$api.admin.master
        .tariffs(this.master.id, { active: true })
        .then(({ data }) => (this.packages = data));
    },
    getRents(more = false) {
      this.loading = true;
      if (more) this.rentPage += 1;
      this.$api.admin
        .masterRentsList({ page: this.rentPage, id: this.master.id })
        .then((response) => {
          this.rents.push.apply(this.rents, response.data);
          this.rentLastPage = response.meta.last_page;
        })
        .finally(() => (this.loading = false));
    },
    sendContract(event) {
      if (!event.target || !event.target.files || !event.target.files[0])
        this.$toast.error("Файл не выбран");
      this.$api.admin.master
        .contract(this.master.id, event.target.files[0])
        .then(({ data }) => {
          this.$emit("new-contract", this.master.id, data.contract);
          this.$toast.success("Скан успешно добавлен!");
        });
    },
    authorize() {
      this.$api.admin.master.authorize(this.master.id).then(({ data }) => {
        this.$emit("authorize", this.master.id, data.authorized_at);
        this.$toast.success("Мастер успешно авторизирован!");
      });
    },
  },
  computed: {
    canLoadMoreRents() {
      return this.rentPage !== this.rentLastPage;
    },
    isFrozen() {
      return this.master.vacation && this.master.frozen.length;
    },
  },
  watch: {
    master(newItem, oldItem) {
      if (newItem.id !== oldItem) this.resetRentData();
      this.getRents();
      this.getTariffs();
      this.frozenDate = this.getDateTimeLocal(
        this.master.frozen[0] ? this.master.frozen[0].end_at : null
      );
    },
  },
};
</script>

<style>
.pd-5px input {
  padding-left: 5px !important;
}
</style>
<style scoped lang="scss">
.right_top_mobile {
  display: none;
}

.more {
  margin-top: 10px;
  margin-bottom: 10px;

  button {
    margin: 0 auto;
    display: flex;
    align-items: center;
    border: none;
    background-color: transparent;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #b9765b;

    &:after {
      content: "";
      width: 20px;
      height: 20px;
      margin-left: 5px;
      background-image: url("../../../../assets/images/icons/chevron-down.svg");
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
}

.wrap_elem {
  height: 100%;
  display: flex;
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06),
    0 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 10px;

  .left {
    min-width: 350px;
    text-align: center;
    padding: 25px 30px;
    border-right: 1px solid #e5e5e5;

    .title {
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      color: #383838;
      margin-bottom: 15px;
    }

    .phone,
    .email {
      font-size: 16px;
      line-height: 24px;
      color: #383838;
      margin-bottom: 10px;
    }

    .authed {
      font-family: "Open Sans", sans-serif;
      font-weight: 600;
      font-size: 12px;
      line-height: 20px;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #0f8a84;

      &.error {
        color: #bb0f0f;
      }
    }

    .button {
      text-decoration: none;
      cursor: pointer;
      background: #dbbfa7;
      border-radius: 5px;
      width: 320px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      font-size: 16px;
      color: #383838;
      margin-bottom: 15px;
    }
  }

  .img {
    margin-bottom: 15px;

    img {
      width: 100px;
      height: 100px;
    }
  }

  .right {
    width: calc(100% - 380px);

    h3 {
      font-weight: 600;
      font-size: 20px;
      color: #383838;
      padding: 20px 30px;
    }

    ul {
      list-style: none;

      li a {
        display: block;
        height: 90px;
        background-color: #ffffff;
        padding: 20px 30px;
        border-bottom: 1px solid #e5e5e5;
        text-decoration: none;
        position: relative;

        //&:after {
        //  content: '';
        //  position: absolute;
        //  width: 20px;
        //  height: 20px;
        //  top: 50%;
        //  transform: translateY(-50%) rotateZ(180deg);
        //  right: 30px;
        //  background-image: url('../../../../assets/images/icons/chevron-left-black.svg');
        //  background-size: contain;
        //}

        .title {
          display: block;
          font-size: 16px;
          line-height: 24px;
          color: #383838;
        }

        .gray {
          font-size: 14px;
          line-height: 24px;
          color: #808080;
          margin-top: 2px;
        }
      }
    }
  }
}

.hidden_inp {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

@media screen and (max-width: 1170px) {
  .right_top_mobile {
    width: 100%;
    display: block;
    padding: 20px 40px 0 40px;

    button {
      background-color: transparent;
      border: none;
    }
  }
  .wrap_elem {
    flex-direction: column;
    align-items: center;

    .left {
      border: none;
      min-width: auto;
      width: 100%;
    }

    .right {
      width: 100%;
      padding-bottom: 40px;

      h3 {
        text-align: center;
      }
    }
  }
}

.img {
  display: flex;
  justify-content: center;
  align-items: center;
}

.img div {
  height: 100px;
  width: 100px;
  background-position: center;
  background-size: cover;
  border-radius: 50%;
  border: 1px solid #dbbfa7;
}

.packages {
  width: calc(100% + 6px);
  padding-right: 6px;
  max-height: 250px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
</style>
